import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionAppInit } from "../app/actionApp";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionEnvSelect } from "./actionEnvSelect";
export var epicEnvSelect = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionEnvSelect.Select), switchMap(function () { return from([actionModalClose(IdModal.EnvSelect), actionAppInit()]); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/env-select/epicEnvSelect.ts
// module id = 1841
// module chunks = 3